// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__21W4h","select":"styles_select__3qqE8"};